import MainLayout from "../../../components/Layouts";
import BulkProductUpload from "../../../components/Shop/Product/bulkupload";

const ShopProductBulkUploadPage = () => {
  return (
    <MainLayout>
      <BulkProductUpload />
    </MainLayout>
  );
};

export default ShopProductBulkUploadPage;
